module.exports = __webpack_public_path__ + "static/img/jg.2c6f00d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/jg.jpg
// module id = Fjhu
// module chunks = 1